import { toast } from "react-toastify";
import { handleErrorMessages } from "../../../global-components/helper";
import { getAuthToken } from "./auth/utils";


// let applicant = localStorage.getItem('__applicant') != undefined ? JSON.parse(localStorage.getItem('__applicant')) : null;
const token = getAuthToken();
// let school = localStorage.getItem('school') != undefined ? JSON.parse(localStorage.getItem('school')) : {};

const environment = window.location.hostname;

let host;

if (environment === 'localhost' || environment === 'eum.tespire.co') host = 'https://api-staging.tespire.ng'; else host = 'https://api.tespire.ng';
const applicantApiRoute = `${host}/applicationportal/applicant`;

async function fetchApplicantData() {

  if (token == null) {
    return null;
  }

  try {
    const response = await fetch(applicantApiRoute, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        xtenant: environment === 'localhost' ? 'eum.tespire.co' : environment,
      },
    });

    const applicantData = await response.json();

    if (applicantData?.data?.error) {
      return null;
    }

    return applicantData?.data?.responseBody || null;
  } catch (error) {
    toast.error(handleErrorMessages(error));
    return null;
  }
}

const applicant = await fetchApplicantData();


const data = {
  // school: school,
  get school() {
    try {
      return JSON.parse(localStorage.getItem("school") || "{}");
    } catch {
      return {};
    }
  },
  applicant: applicant != undefined ? applicant : "",
  host: host,
  // host: 'http://192.168.105.116:8005',
  cloud: 'https://filesupload.jdlabserver.com',
  // printHost: 'https://www.jsp.ng/',
  printHost: host,
  token: token != undefined ? token : '',
  // id: applicant != undefined ? applicant.id : '',
  headers: {
    Authorization: 'Bearer ' + (token != undefined ? token : ''),
    // xtenant: window.location.hostname
    xtenant: environment === 'localhost' ? 'eum.tespire.co' : environment
    // xtenant: environment === 'localhost' ? 'coeminna.tespire.co' : environment
    // xtenant: environment === 'localhost' ? 'somidminna.tespire.co' : environment
    // xtenant: environment === 'localhost' ? 'ibbulvtp.tespire.co' : environment
    // xtenant: environment === 'localhost' ? 'ibbuiceel.tespire.co' : environment
  }
}




export default data 
